import { PortableText } from '@portabletext/react';
import { Link } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import PropTypes from 'prop-types';
import React from 'react';
import { Container } from 'react-bootstrap';
import imgFallback from 'src/utils/image';
import { InnerCta } from './InnerCta';
import * as styles from './SectionsWithInnerCta.module.scss';

export const SectionsWithInnerCta = ({ sections }) => {
  if (sections.length === 0) {
    return null;
  }

  return (
    <div className={styles.articles}>
      {sections.map(({ _key, title, tagline, description, image, links, innerCta }) => (
        <div key={_key} className={styles.articleContainer}>
          <div className={styles.articleBgImage} />
          <div className={styles.articleFullBg}>
            <Container>
              <div className={styles.article}>
                <div className={`${styles.header} mt-4`}>
                  <p className="text-uppercase">{tagline}</p>
                  <h2 className="h3">{title}</h2>
                </div>

                <div className={styles.description}>
                  <PortableText value={description} />
                </div>

                {links.length && (
                  <div className={styles.links}>
                    {links.map((link) => (
                      <Link key={link._key} to={link.url} className="btn-link-primary text-uppercase">
                        {link.title}
                      </Link>
                    ))}
                  </div>
                )}

                {innerCta && (
                  <div className={styles.cta}>
                    <InnerCta {...innerCta} />
                  </div>
                )}

                <div className={`${styles.image} mb-3`}>
                  <GatsbyImage alt={image?.alt ?? ''} image={image?.image?.asset?.gatsbyImageData ?? imgFallback} />
                </div>
              </div>
            </Container>
          </div>
        </div>
      ))}
    </div>
  );
};

SectionsWithInnerCta.propTypes = {
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      tagline: PropTypes.string.isRequired,
      description: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
      image: PropTypes.shape(PropTypes.shape({})).isRequired,
      links: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
      innerCta: PropTypes.shape({
        title: PropTypes.string.isRequired,
        description: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
        image: PropTypes.shape({}).isRequired,
        link: PropTypes.shape({}).isRequired,
      }),
    })
  ).isRequired,
};
